export const journeyPermissions = [
  'AUTENTICA:FLUXO:BASIC',
  'AUTENTICA:FLUXO:COMPLETO',
  'AUTENTICA:FLUXO:CONNECTION',
  'AUTENTICA:SMS:ENVIAR',
];

export const localizeSearchPermissions = ['LOCALIZE:CPF'];
